import { Helmet } from "react-helmet-async"
import { TrendingUp, Users, Building2, Stethoscope } from "lucide-react"

export default function Achievements() {
  const milestones = [
    { year: "2024", event: "Opened 4th facility in Zaheerabad", icon: Building2 },
    { year: "2023", event: "Achieved NABH Accreditation", icon: TrendingUp },
    { year: "2022", event: "Completed 50,000+ successful deliveries", icon: Users },
    { year: "2021", event: "Expanded to Isnapur with advanced ICU", icon: Stethoscope },
    { year: "2020", event: "Launched 24/7 Emergency Services", icon: TrendingUp },
    { year: "2019", event: "Opened Nallagandla Branch", icon: Building2 }
  ]

  const stats = [
    { number: "50,000+", label: "Patients Treated Annually" },
    { number: "4", label: "Hospital Locations" },
    { number: "100+", label: "Medical Professionals" },
    { number: "20+", label: "Specialties" }
  ]

  return (
    <>
      <Helmet>
        <title>Achievements & Milestones - Pranaam Hospitals</title>
      </Helmet>
      
      <div className="min-h-screen bg-gray-50">
        <div className="relative h-64 md:h-96 bg-gradient-to-r from-brand-teal to-brand-nickel">
          <img src="/images/ResearchExcellence.png" alt="Excellence" className="w-full h-full object-cover opacity-20" />
          <div className="absolute inset-0 flex items-center justify-center">
            <h1 className="text-3xl md:text-5xl font-bold text-white text-center px-4">Achievements & Milestones</h1>
          </div>
        </div>

        <div className="container mx-auto px-4 py-8 md:py-16">
          <div className="max-w-6xl mx-auto">
            <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
              {stats.map((stat, index) => (
                <div key={index} className="bg-white rounded-lg shadow-lg p-6 text-center">
                  <div className="text-3xl md:text-4xl font-bold text-brand-teal mb-2">{stat.number}</div>
                  <div className="text-gray-700">{stat.label}</div>
                </div>
              ))}
            </div>

            <div className="bg-white rounded-lg shadow-lg p-6 md:p-10">
              <h2 className="text-2xl md:text-3xl font-bold text-brand-teal mb-8 text-center">Our Journey</h2>
              <div className="space-y-6">
                {milestones.map((milestone, index) => {
                  const Icon = milestone.icon
                  return (
                    <div key={index} className="flex gap-4 md:gap-6 items-start">
                      <div className="flex-shrink-0">
                        <div className="w-12 h-12 md:w-16 md:h-16 bg-brand-teal/10 rounded-full flex items-center justify-center">
                          <Icon className="w-6 h-6 md:w-8 md:h-8 text-brand-teal" />
                        </div>
                      </div>
                      <div className="flex-1 pb-6 border-b border-gray-200 last:border-0">
                        <div className="text-brand-teal font-bold text-lg md:text-xl mb-2">{milestone.year}</div>
                        <p className="text-gray-700 text-base md:text-lg">{milestone.event}</p>
                      </div>
                    </div>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
